<script>
    // Приветствие «Welcome to JUST RP» — титр в катсцене прилёта в Лос-Сантос
    // (квест «Дорога в Лос-Сантос»). Рисуем интерфейсом, а не игровым шрифтом:
    // игровой drawText не умеет ни жирного начертания, ни фирменного золота.
    //
    // Показ: window.lsWelcome(1) — появиться, window.lsWelcome(0) — убрать.
    // Уходит сам: жизнь титра задана анимацией, отдельный таймер не нужен.
    let show = false;
    window.lsWelcome = (on) => { show = !!(on && on !== '0'); };
</script>

{#if show}
<div class="lw">
    <div class="lw__kicker">Welcome to</div>
    <div class="lw__logo"><span class="lw__j">Just</span><span class="lw__rp">RP</span></div>
    <div class="lw__rule"></div>
</div>
{/if}

<style>
    .lw {
        position: fixed; inset: 0; z-index: 90;
        display: flex; flex-direction: column;
        align-items: center; justify-content: center;
        pointer-events: none;
        font-family: 'Manrope', 'Gilroy', sans-serif;
        animation: lw-life 9s ease-in-out forwards;
    }

    /* Буквы italic + очень жирные — как в логотипе проекта. */
    .lw__kicker {
        font-size: 2.6vh; font-weight: 800; font-style: italic;
        letter-spacing: .62em; text-indent: .62em; text-transform: uppercase;
        color: rgba(255, 255, 255, .78);
        text-shadow: 0 .2vh 1.4vh rgba(0, 0, 0, .75);
        margin-bottom: 1.6vh;
    }

    .lw__logo {
        font-size: 19.6vh; line-height: .92; font-weight: 900; font-style: italic;
        letter-spacing: -.018em; text-transform: uppercase; white-space: nowrap;
        text-shadow: 0 1vh 3.4vh rgba(0, 0, 0, .72), 0 .2vh 0 rgba(0, 0, 0, .35);
    }
    .lw__j { color: #FFFFFF; }
    .lw__rp { color: #E7AE3F; }

    .lw__rule {
        margin-top: 2.4vh; height: .4vh; width: 61vh; border-radius: .2vh;
        background: linear-gradient(90deg, transparent, #E7AE3F 18%, #E7AE3F 82%, transparent);
        box-shadow: 0 0 2vh rgba(231, 174, 63, .55);
        animation: lw-rule 9s ease-in-out forwards;
    }


    /* Появление снизу вверх, выдержка, мягкий уход. */
    @keyframes lw-life {
        0%   { opacity: 0; transform: translateY(2.2vh); }
        14%  { opacity: 1; transform: translateY(0); }
        78%  { opacity: 1; transform: translateY(0); }
        100% { opacity: 0; transform: translateY(-1.2vh); }
    }
    /* Линия под логотипом разъезжается из центра. */
    @keyframes lw-rule {
        0%   { transform: scaleX(0); }
        26%  { transform: scaleX(1); }
        100% { transform: scaleX(1); }
    }
</style>
